import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';

export default function DisconnectDialog(props) {
  const { onClose, open, disconnectFunction } = props;

  const handleClose = () => {
    onClose();
  };


  const disconnect = () => {
  	disconnectFunction();
  	onClose();
  }

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Are you sure you want to leave?</DialogTitle>
      <List sx={{ pt: 0 }}>
          <ListItem disablePadding key={"disconnectButton"}>
            <ListItemButton onClick={() => disconnect()}>
              <ListItemText primary={"Yes, leave"} />
            </ListItemButton>
          </ListItem>
  		  <ListItem disablePadding key={"cancelButton"}>
            <ListItemButton onClick={() => handleClose()}>
              <ListItemText primary={"No, stay"} />
            </ListItemButton>
          </ListItem>
      </List>
    </Dialog>
  );
}